export const ERROR_OCCURRED = 'dashboard/errors/ERROR_OCCURRED';
